<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'GympassModule',
    props: {
      // only get prop options key
      options: {
        type: Object,
        default: _ => {},
      },
    },
  }
</script>
